export default __webpack_public_path__ + "static/P_SearchThumb_InfraredSpotlights-7fdf7b2ae0b6d5742fdb7767da446d37.webp";